import mixpanel from "mixpanel-browser";
import { select } from "redux-saga/effects";

import { buildTrackingData } from "common/utilities/buildTrackingData";
import type { TrackMeta } from "domains/analytics/types";
import { getSiteLanguage } from "domains/language/selectors";

export function* trackSaga({ name, ...rest }: TrackMeta) {
  const siteLanguage: ReturnType<typeof getSiteLanguage> = yield select(getSiteLanguage);
  mixpanel.track(name, buildTrackingData(siteLanguage, rest));
}
